<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-text class="d-flex align-center justify-space-between flex-wrap">
                    <h6 class="text-h6 font-weight-bold mb-0">
                        {{ survey.title }} <br />
                        <small><span class="text-red">From: {{ moment(survey.startDate).format("D-MMM-yyyy") }} To: {{
                            moment(survey.endDate).format("D-MMM-yyyy") }}</span></small>
                    </h6>
                    <v-btn
                        size="small"
                        prepend-icon="mdi-file-excel"
                        :loading="downloading"
                        @click="downloadExcel"
                    >
                        Download Excel
                    </v-btn>
                </v-card-text>
            </v-card>
            <v-card class="my-2">
                <v-card-text class="pa-0">
                    <div class="report-scroll">
                        <table class="tbl-report">
                            <thead>
                                <tr>
                                    <th>Its Id</th>
                                    <th>Full Name</th>
                                    <th>Team</th>
                                    <th>Section</th>
                                    <th>Rank</th>
                                    <th v-for="question in survey.questions" :key="question.questionId">
                                        {{ question.reportHeader }}{{ question.isActive === false ? ' (Inactive)' : '' }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="rec in report" :key="rec.ItsId">
                                    <td>{{ rec.ItsId }}</td>
                                    <td>{{ rec.FullName }}</td>
                                    <td>{{ rec.Team }}</td>
                                    <td>{{ rec.Section }}</td>
                                    <td>{{ rec.Rank }}</td>
                                    <td v-for="question in survey.questions" :key="question.questionId">
                                        <template v-if="question.questionType == 'FileUpload'">
                                            <template v-if="isImageUrl(rec[question.reportHeader].split(' ')[0])">
                                                <ImageZoom :src="img" v-for="(img, i) in rec[question.reportHeader].split(' ')"
                                                    :key="`img_${i}`" />
                                            </template>
                                            <template v-else>
                                                <a :href="url" target="_blank"
                                                    v-for="(url, i) in rec[question.reportHeader].split(' ')" :key="`a_${i}`"
                                                    style="display:block;">View File</a>
                                            </template>
                                        </template>
                                        <template v-else>
                                            {{ rec[question.reportHeader] }}
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script setup>
import { ref, inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import moment from 'moment';
import * as surveyService from '@/services/surveyService';
import ImageZoom from '@/components/imageZoom.vue';

const loader = inject("loader");
const snackbar = inject("snackBar");
const route = useRoute();

const surveyId = route.params.id;
const survey = ref({});
const report = ref([]);
const downloading = ref(false);

function isImageUrl(url) {
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url);
}

async function getData() {
    loader.show();

    let result = await surveyService.getReport(surveyId)
        .catch(error => {
            console.log(error);
            snackbar.error(error);
        })
        .finally(async () => {
            loader.hide();
        });

    if (result) {
        survey.value = result.survey;
        report.value = result.report;
    }
}

async function downloadExcel() {
    downloading.value = true;
    try {
        const blob = await surveyService.exportReport(surveyId);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `survey_report_${surveyId}_${moment().format('DDMMMYYYY_HHmm')}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    } catch (error) {
        snackbar.error(error);
    } finally {
        downloading.value = false;
    }
}

onMounted(async () => {
    await getData();
})

</script>

<style>
.report-scroll {
    overflow-x: auto;
    width: 100%;
}

.tbl-report {
    width: 100%;
    min-width: max-content;
    border-collapse: collapse;
    border-radius: 10px;
}

.tbl-report th,
.tbl-report td {
    padding: 8px 12px;
    white-space: nowrap;
    border-bottom: 1px Solid #666;
}

.tbl-report th {
    position: sticky;
    top: 0;
    background: rgb(var(--v-theme-surface));
    z-index: 1;
}
</style>
